import React from "react";
import PortfolioPage from "./pages/PortfolioPage/PortfolioPage";

const Routes = () => <PortfolioPage />;

export default Routes;
